<template>
  <div class="nav-actions">
    <DietListNav
      :diet-type="dietType"
      :drag-to-nav="dragToNav"
      @drop-from-nav="emit('drop', $event)"
    />
    <div class="actions">
      <div class="copy-diet-wrapper">
        <Tooltip placement="top-end">
          <template #trigger>
            <IconButton
              name="filter_none"
              icon-size="18"
              :disabled="!someDietsSelected"
              @click.stop="emit('show-copy')"
            />
          </template>
          Skopiuj zaznaczone szablony do Twojej grupy
        </Tooltip>
        <DietListCopyMoveMenu
          v-if="copyMenuVisible"
          class="copy-diet-menu"
          title="Skopiuj do:"
          :groups="groups"
          :hide-add-group="true"
          @select-group="emit('copy', $event)"
          @close="emit('close-copy')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import DietListCopyMoveMenu from '@/components/diets/DietListCopyMoveMenu.vue'
  import DietListNav from '@/components/diets/DietListNav.vue'
  import { IconButton } from '@/components/IconButton'
  import { Tooltip } from '@/components/ui'

  import type { DietType, UserGroup } from '@/store/types'

  defineProps<{
    copyMenuVisible: boolean
    dietType: DietType
    dragToNav: boolean
    groups: UserGroup[]
    someDietsSelected: boolean
  }>()
  const emit = defineEmits<{
    'close-copy': []
    copy: [groupId: number]
    drop: [event: DragEvent]
    'show-copy': []
  }>()
</script>
